import {
    db,
    serverTimestamp,
} from '../config/firebase';

function setSampleProducts(applicationId) {
    return new Promise((resolve, reject) => {
        const collection = db.collection('applications');
        const state = {
            lastUpdate: serverTimestamp(),
            formStepper: {
                activeStep: 2,
            },
        };
        collection
            .doc(applicationId)
            .update(state)
            .then(() => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export default setSampleProducts;



// WEBPACK FOOTER //
// ./src/service/setSampleProducts.js